export const colors = {
  primary: 'var(--color-primary)',
  primary30: 'var(--color-primary-30)',
  secondary: 'var(--color-secondary)',
  error: 'var(--color-error)',
  title: 'var(--color-title)',
  text: 'var(--color-text)',
  background: 'var(--color-background)',
  textLight: 'var(--color-text-light)',
  textGrey: 'var(--color-text-grey)',
  textGreyDark: 'var(--color-text-grey-30)',
  violetLight: 'var(--color-violet-light)',
} as const;

export type Colors = keyof typeof colors;
